import React from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";

import {
  Context,
  fetchStudents,
  notFoundPath,
  classDataPath,
  clearStudents,
  clearActiveLearningInquiryEvaluations,
  clearActiveLearningInquiryEvaluationsCSV,
  activeLearningClassDataPath,
  fetchActiveLearningInquiryEvaluations,
  fetchActiveLearningInquiryEvaluationsDownloadCSV,
  FETCH_ACTIVE_LEARNING_INQUIRY_EVALUATIONS_DOWNLOAD_CSV_SUCCESS,
} from "../../../teacherStore";
import { ActiveLearningMaterialCode, IStudent } from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import ActiveLearningStudentList from "../../../templates/teacher/ActiveLearningStudentList";

export default () => {
  const { state: locationState } = useLocation<{
    nameClass: string;
  }>();
  const history = useHistory();
  const { state, dispatch } = React.useContext(Context);
  const params = useParams<{ class_id: string }>();
  const class_id = parseInt(params.class_id);
  const nameClass = locationState?.nameClass;
  const [calling, peep] = useWaitApiCall(state);
  const [isSuccessCSVDownload, setIsSuccessCSVDownload] = React.useState(false);

  React.useEffect(() => {
    if (!nameClass) {
      history.replace(notFoundPath);
    }
  }, [history, nameClass]);

  React.useEffect(() => {
    dispatch(fetchStudents([class_id]));
    dispatch(fetchActiveLearningInquiryEvaluations(class_id));

    return () => {
      dispatch(clearStudents());
      dispatch(clearActiveLearningInquiryEvaluations());
      dispatch(clearActiveLearningInquiryEvaluationsCSV());
    };
  }, [class_id, dispatch]);

  const links = React.useMemo(
    () => [
      {
        name: `クラスデータ`,
        to: classDataPath,
        search: "?isActiveLearning=true",
      },
      {
        name: nameClass ?? "",
        to: "#",
      },
    ],
    [nameClass],
  );

  const goBack = React.useCallback(
    () => history.push(`${classDataPath}?isActiveLearning=true`),
    [history],
  );

  const goToStudentResponse = React.useCallback(
    (student: IStudent) =>
      history.push(
        `${activeLearningClassDataPath}/${class_id}/student/${student.id}/response`,
        {
          students: state.students,
          nameClass,
        },
      ),
    [class_id, history, nameClass, state.students],
  );

  const handleDownloadInquiryEvaluationCSV = React.useCallback(
    (material_code: ActiveLearningMaterialCode) => {
      setIsSuccessCSVDownload(false);
      dispatch(
        peep(
          fetchActiveLearningInquiryEvaluationsDownloadCSV(
            class_id,
            material_code,
          ),
        ),
      );
    },
    [dispatch, peep, class_id],
  );

  React.useEffect(() => {
    if (
      state.lastAction ===
      FETCH_ACTIVE_LEARNING_INQUIRY_EVALUATIONS_DOWNLOAD_CSV_SUCCESS
    ) {
      setIsSuccessCSVDownload(true);
    }
  }, [state.lastAction]);

  return nameClass ? (
    <ActiveLearningStudentList
      listStudents={state.students}
      calling={calling}
      nameClass={nameClass}
      links={links}
      isSuccessCSVDownload={isSuccessCSVDownload}
      goBack={goBack}
      goToStudentResponse={goToStudentResponse}
      onDownloadInquiryEvaluationCSV={handleDownloadInquiryEvaluationCSV}
    />
  ) : null;
};
